import { cloneDeep } from 'lodash';
import Vue from 'vue';

export function makeObservable (obj) {
  obj = cloneDeep(obj);
  const vm = new Vue({ data: obj });

  Object.defineProperty(obj, '__vm__', {
    get () { return vm; }
  });

  return obj;
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/make-observable.js